import { Button, Input, Label, PasswordInput } from "@akin2unde/flowui-react";
import { Login } from "./Login";
import TenantBrand from "../../components/TenantBrand/TenantBrand";
import { useTenant } from "../../tenant/useTenant";
import "./LoginCss.css";

export default function LoginHTML() {
  const { state, setStateProperty, submit } = Login();
  const { Tenant } = useTenant();

  return (
    <main className="login-page">
      <section className="login-panel">
        <TenantBrand />

        <div className="login-heading">
          <h1>{Tenant?.BusinessName ?? "PantryStack"} Admin</h1>
          <p>Sign in to manage your business.</p>
        </div>

        <form className="login-form" onSubmit={submit}>
          <div className="login-field">
            <Label htmlFor="email" required>
              Email address
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="username"
              required
              value={state.email}
              placeholder="admin@example.com"
              onChange={(event) =>
                setStateProperty("email", event.target.value)
              }
            />
          </div>

          <div className="login-field">
            <Label htmlFor="password" required>
              Password
            </Label>
            <PasswordInput
              id="password"
              name="password"
              autoComplete="current-password"
              required
              showToggle
              value={state.password}
              placeholder="Enter your password"
              onChange={(event) =>
                setStateProperty("password", event.target.value)
              }
            />
          </div>

          <Button type="submit" width="100%">
            Sign in
          </Button>
        </form>
      </section>
    </main>
  );
}
